/* eslint-disable unicorn/no-this-assignment */
/* eslint-disable no-console */
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';
import Select from '../../components/Select';
import { Events } from '../../utils/dom/html-events';

const CLICK_EVENT = 'click';
const ENTER_KEY = '13';

class OffCourt {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.lta-off-court-resources');
		if (!this._wrapper) {
			return;
		}
		this.initEvents();
		this.state = {
			serachInput: '',
			selectedSubjects: [],
			selectedFormats: [],
			selectedLevels: []
		};
	}

	initEvents() {
		// Events on Tabs Changes and Searches
		const current = this;
		const serachInputText = SelectorEngine.findOne('#search-off-court', this._wrapper);
		const searchButton = SelectorEngine.findOne('.off-court-search-btn', this._wrapper);
		const subject = SelectorEngine.findOne('.lta-off-court-subject-select', this._wrapper);
		const format = SelectorEngine.findOne('.lta-off-court-format-select', this._wrapper);
		const level = SelectorEngine.findOne('.lta-off-court-level-select', this._wrapper);

		if (serachInputText) {
			EventHandler.on(serachInputText, 'change', (event) => {
				this.saveSerachInput(event);
			});
		}

		if (subject) {
			this.subjectElement = SelectorEngine.findOne('.js-lta-select', subject);
			this.subjectSelect = Select.getInstance(this.subjectElement) || new Select(this.subjectElement);
			EventHandler.on(this.subjectSelect._selectNativeElement, 'change', (event) => {
				this.saveSubjects(event);
			});
		}

		if (format) {
			this.formatElement = SelectorEngine.findOne('.js-lta-select', format);
			this.formatSelect = Select.getInstance(this.formatElement) || new Select(this.formatElement);
			EventHandler.on(this.formatSelect._selectNativeElement, 'change', (event) => {
				this.saveFormats(event);
			});
		}

		if (level) {
			this.levelElement = SelectorEngine.findOne('.js-lta-select', level);
			this.levelSelect = Select.getInstance(this.levelElement) || new Select(this.levelElement);
			EventHandler.on(this.levelSelect._selectNativeElement, 'change', (event) => {
				this.saveLevel(event);
			});
		}

		const applyFilter = SelectorEngine.findOne('.lta-off-court__btn', this._wrapper);
		const applyFilterMobile = SelectorEngine.findOne('.lta-off-court__btn-mobile', this._wrapper);
		const formElement = SelectorEngine.findOne('.js-off-court-search-form', this._wrapper);

		EventHandler.on(searchButton, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(applyFilter, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(applyFilterMobile, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(serachInputText, Events.Keydown, (event) => {
			const key = event.keyCode || event.which;
			if (key == ENTER_KEY) {
				event.preventDefault();
				this.generateQueryString(formElement);
			}
		});

		const allBookmarkContainers = SelectorEngine.find('.lta-bookmark-container', this._wrapper);
		for (const container of allBookmarkContainers) {
			const addBookmarkButton = SelectorEngine.findOne('.lta-add-bookmark', container);
			const removeBookmarkButton = SelectorEngine.findOne('.lta-remove-bookmark', container);

			EventHandler.on(addBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(addBookmarkButton, 'page-id');
				this.addBookmark(event, pageId, removeBookmarkButton);
			});

			EventHandler.on(removeBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(removeBookmarkButton, 'page-id');
				this.removeBookmark(event, pageId, addBookmarkButton);
			});
		}
	}

	saveSerachInput(event) {
		const targetValue = event.target.value;
		this.state.serachInput = targetValue;
	}

	saveSubjects(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedSubjects = selectedValues;
	}

	saveFormats(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedFormats = selectedValues;
	}

	saveLevel(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedLevels = selectedValues;
	}

	generateQueryString(formElement) {
		formElement.submit();
	}

	encodeParam(value) {
		return encodeURIComponent(value.replace(/&/g, '&amp;'));
	}

	async addBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/bookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async removeBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/unbookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}

const globalOffCourt = new OffCourt();
export default globalOffCourt;
